module.exports = __webpack_public_path__ + "img/major-gold.0b7ae30f.webp";